module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"complete":{"new":"Registration completed.<br>Regards TEBSTA !","edit":"Update completed."},"signup":{"label":"Sign up now"}},"ja":{"complete":{"new":"登録が完了しました。<br>TEBSTAをよろしくお願いします！","edit":"更新が完了しました。"},"signup":{"label":"ログインする"}}}')
  delete Component.options._Ctor
}
